export default __webpack_public_path__ + "static/media/BSS_AI.6341600e.svg";